module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Medium-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Medium-webfont.eot
// module id = 691
// module chunks = 0